module.exports = __webpack_public_path__ + "img/pricing_year.3e8cfe00.svg";